import * as React from "react";
import {
  Divider,
  Grid,
  Typography,
  Tooltip,
  useTheme,
  useMediaQuery,
  Skeleton,
  Chip,
  Button,Box
} from "@mui/material";
import postsServices from "../../../services/api/service/postsService";
import { decrypt } from "../../../utils/crypto";
import { formatDate } from "../../../utils/dateFormatUtils";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";

interface DisbursementFormTermDetailsProps {
  disbursementFormId: number;
  validConsent: any;
  formStatus?: string;
  onClickFunc?: () => void;
}

const DisbursementFormTermDetails: React.FC<
  DisbursementFormTermDetailsProps
> = ({ disbursementFormId,validConsent,formStatus,onClickFunc }) => {
  const [disbursementFormDetails, setDisbursementFormDetails] =
    React.useState<any>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  const handleInvokDetailApi = async () => {
    try {
      const payload = {
        disbursementFormId: disbursementFormId,
      };
      const response: any = await postsServices.addPost(
        "api/v1/disbursement-form/review-details",
        payload
      );
      if (response?.status == 200) {
        setIsLoading(false);
        setDisbursementFormDetails(JSON.parse(decrypt(response?.data?.data)));
      }
    } catch (error: any) {
      setIsLoading(false);
      console.log(error);
    }
  };
  React.useEffect(() => {
    handleInvokDetailApi();
  }, [disbursementFormId]);

  React.useEffect(() => {
    // Scroll to the top of the page on component mount
    window.scrollTo(0, 0);
  }, []);
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"))
  let data=disbursementFormDetails[0] || {};
  const handleButton=()=>{
    if (
      formStatus != "query" &&
      formStatus != "pendingFromOperationMaker" &&
      formStatus != "pendingFromOperationChecker" &&
      formStatus != "pendingFromLienOperationChecker" &&
      formStatus != "pendingFromCredit" &&
      formStatus != "pendingFromCollection" &&
      formStatus != "pendingFromSalesCoordinator" &&
      formStatus != "approve" &&
      formStatus != "reject" &&
      formStatus != "cancelled"
    ) {
      return (
      <Button
            variant="outlined"
            size="small"
            startIcon={<DriveFileRenameOutlineIcon sx={{ fontSize: 16 }} />}
            sx={{
              textTransform: "none",
              borderColor: "#00b3ad",
              color: "#00b3ad",
              fontWeight: 500,
              "&:hover": {
                borderColor: "#009a94",
                backgroundColor: "rgba(0,179,173,0.05)",
              },
            }}
            onClick={onClickFunc}
          >
            Edit
          </Button>
      )
    }
  }
  console.log(data,"data")
  return (
    <>
      <div style={{ padding: isXsOrSm ? "0px" : "20px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 1,
          }}
        >
          {/* Left text */}
            <Typography 
              sx={{
                color: "rgba(22, 135, 148, 1)",
                fontSize: "15px",
                fontWeight: "600",
                letterSpacing: "1px",
                marginTop: isXsOrSm ? "8px" : "-5px",
              }}
            >
                  REVIEW DETAILS
          </Typography>
          {/* Right button */}
          {handleButton()}
          
        </Box>
        <Divider sx={{ paddingTop: "10px", marginBottom: "15px" }} />

        {isLoading ? (
          <>
            <Grid container spacing={2}>
              {Array.from(new Array(5)).map((_, index) => (
                <Grid item xs={6} sm={6} md={4} lg={3} key={index}>
                  <div style={{ padding: "10px" }}>
                    <Skeleton variant="text" width="80%" />
                    <Skeleton variant="text" width="60%" />
                  </div>
                </Grid>
              ))}
            </Grid>
          </>
        ) : (
          <>
            {/* {disbursementFormDetails?.map((formDetail: any, index: number) => (
              <Grid container key={index} className="dashboard-container">
                {Object.entries(formDetail).map(([key, value]: any) => {
                  // Skip empty values and keys containing "Id" or "id"
                  if (
                    value === null ||
                    value === "" ||
                    value === undefined ||
                    key.includes("Id") ||
                    key.includes("id")
                  )
                    return null;

                  // Format created_at and updated_at using Day.js
                  if (
                    key === "created_at" ||
                    key === "updated_at" ||
                    key === "paymentDate" ||
                    key === "disbursementDate" ||
                    key === "requestSubmissionDate"
                  ) {
                    value = formatDate(value);
                  }

                  if (key === "overseasNumber") {
                    value = `+${value}`;
                  }

                  return (
                    <React.Fragment key={key}>
                      <Grid item xs={6} sm={6} md={4} lg={3}>
                        <Typography className="insidePageLable">
                          {key == "ifsccode" || key == "overseasaddress" || key == "paymentTypeName" || key == "disbursementPurposeName" || key == "disbAmount" ? (
                            <>
                              {key == "ifsccode" && "IFSC Code"}
                              {key == "overseasaddress" && "Overseas Address"}
                              {key == "paymentTypeName" && "Payment Type"}
                              {key == "disbursementPurposeName" && "Disbursement Purpose"}
                              {key == "disbAmount" && "Disbursement Amount"}
                            </>
                          ) : (
                            <>
                              {formatKeyToLabel(key)}:
                            </>
                          )}

                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6} md={4} lg={3}>
                        <Typography className="insidePageValue_dis text-disable">
                          {value}
                        </Typography>
                      </Grid>
                    </React.Fragment>
                  );
                })}
              </Grid>
            ))} */}
            <Grid item sm={12}>
              <Typography
                sx={{
                  color: "rgba(22, 135, 148, 1)",
                  fontSize: "15px",
                  fontWeight: "600",
                  letterSpacing: "1px",
                  marginTop: isXsOrSm ? "8px" : "-5px",
                }}
              >
                Fund Request Details
              </Typography>
            </Grid>
            <Grid container className="dashboard-container">
                <React.Fragment>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageLable">
                      Request Type
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageValue_dis text-disable">
                      {data?.requestType==="lien"?"Fund Release from Lien A/c":data?.requestType==="tranche"?"New Tranche":"-"}
                    </Typography>
                  </Grid>
                </React.Fragment>
                <React.Fragment>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageLable">
                      Payment Type
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageValue_dis text-disable">
                      {data?.paymentTypeName}
                    </Typography>
                  </Grid>
                </React.Fragment>
                <React.Fragment>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageLable">
                      Disbursement Purpose
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageValue_dis text-disable">
                      {data?.disbursementPurposeName}
                    </Typography>
                  </Grid>
                </React.Fragment>
                <React.Fragment>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageLable">
                      Account Type
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageValue_dis text-disable">
                      {data?.accountType}
                    </Typography>
                  </Grid>
                </React.Fragment>
                <React.Fragment>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageLable">
                      University Name
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageValue_dis text-disable">
                      {data?.universityName}
                    </Typography>
                  </Grid>
                </React.Fragment>
                <React.Fragment>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageLable">
                      Updated University Name
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageValue_dis text-disable">
                      {data?.newUniversityName ?? "-"} 
                    </Typography> 
                  </Grid>
                </React.Fragment>
                <React.Fragment>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageLable">
                      Payment Date
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageValue_dis text-disable">
                      {data?.paymentDate?formatDate(data?.paymentDate):"-"}
                    </Typography>
                  </Grid>
                </React.Fragment>
                <React.Fragment>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageLable">
                      Payment Made To
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageValue_dis text-disable">
                     {data?.paymentMadeTo ? data?.paymentMadeTo : "-"}
                    </Typography>
                  </Grid>
                </React.Fragment>
                <React.Fragment>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageLable">
                      Requested Amount
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageValue_dis text-disable">
                      {data?.requestedAmount}
                    </Typography>
                  </Grid>
                </React.Fragment>
                <React.Fragment>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageLable">
                      Overseas Number
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageValue_dis text-disable">
                      {data?.overseasNumber?  `+${data?.overseasNumber}` : "-"}
                    </Typography>
                  </Grid>
                </React.Fragment>
                <React.Fragment>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageLable">
                      Overseas Address
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageValue_dis text-disable">
                      {data?.overseasaddress? data?.overseasaddress : "-"}
                    </Typography>
                  </Grid>
                </React.Fragment>
                <React.Fragment>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageLable">
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={6} md={4} lg={3}>
                    <Typography className="insidePageValue_dis text-disable">
                    </Typography>
                  </Grid>
                </React.Fragment>
              </Grid>
              {(data?.lienAccountHolderName ||
              data?.lienAccountNumber || data?.lienIfscCode)&&
              <>  
                <Grid item sm={12}>
                  <Typography
                    sx={{
                      color: "rgba(22, 135, 148, 1)",
                      fontSize: "15px",
                      fontWeight: "600",
                      letterSpacing: "1px",
                      marginTop: isXsOrSm ? "8px" : "5px",
                    }}
                  >
                    Lien A/c Details
                  </Typography>
                </Grid>
                <Grid container className="dashboard-container">
                  <React.Fragment>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                      <Typography className="insidePageLable">
                        Bank Name
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                      <Typography className="insidePageValue_dis text-disable">
                        {data?.LienBankData?.bankName}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                  <React.Fragment>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                      <Typography className="insidePageLable">
                        Account Number
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                      <Typography className="insidePageValue_dis text-disable">
                        {data?.lienAccountNumber}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                  <React.Fragment>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                      <Typography className="insidePageLable">
                        IFSC Code
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                      <Typography className="insidePageValue_dis text-disable">
                        {data?.lienIfscCode}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                  <React.Fragment>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                      <Typography className="insidePageLable">
                        Acc Holder Name
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                      <Typography className="insidePageValue_dis text-disable">
                        {data?.lienAccountHolderName}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                  <React.Fragment>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                      <Typography className="insidePageLable">
                        Account Information Consent
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                     {validConsent===true &&
                      <Chip
                            label="Consent received"
                            sx={{
                              bgcolor: "#068906",
                              color: "white",
                              fontWeight: 500,
                              fontSize: "12px",
                              borderRadius: "4px !important",
                              height: "22px",
                              marginBottom:"5px"
                            }}
                          />
                        }
                        {validConsent===false  && 
                          <Chip
                            label="No consent received"
                            sx={{
                              bgcolor: "#ff8f24",
                              color: "white",
                              fontWeight: 500,
                              fontSize: "12px",
                              borderRadius: "4px !important",
                              height: "22px",
                              marginBottom:"5px"
                            }}
                          />
                        }
                        {validConsent==="in-progress"  && 
                          <Chip
                            label="In Progress"
                            sx={{
                              bgcolor: "#ff8f24",
                              color: "white",
                              fontWeight: 500,
                              fontSize: "12px",
                              borderRadius: "4px !important",
                              height: "22px",
                              marginBottom:"5px"
                            }}
                          />
                        }
                    </Grid>
                  </React.Fragment>
                  <React.Fragment>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                      <Typography className="insidePageLable">
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                      <Typography className="insidePageValue_dis text-disable">
                      </Typography>
                    </Grid>
                  </React.Fragment>
                </Grid>
              </>
             }
             {(data?.accHolderName ||
              data?.accountNumber || data?.ifsccode)&&
              <> 
                <Grid item sm={12}>
                  <Typography
                    sx={{
                      color: "rgba(22, 135, 148, 1)",
                      fontSize: "15px",
                      fontWeight: "600",
                      letterSpacing: "1px",
                      marginTop: isXsOrSm ? "8px" : "8px",
                    }}
                  >
                    Beneficiary Bank Details
                  </Typography>
                </Grid>
                <Grid container className="dashboard-container">
                  <React.Fragment>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                      <Typography className="insidePageLable">
                        Bank Name
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                      <Typography className="insidePageValue_dis text-disable">
                        {data?.BankData?.bankName}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                  <React.Fragment>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                      <Typography className="insidePageLable">
                        Account Number
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                      <Typography className="insidePageValue_dis text-disable">
                        {data?.accountNumber}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                  <React.Fragment>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                      <Typography className="insidePageLable">
                        IFSC Code
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                      <Typography className="insidePageValue_dis text-disable">
                        {data?.ifsccode}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                  <React.Fragment>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                      <Typography className="insidePageLable">
                        Acc Holder Name
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={3}>
                      <Typography className="insidePageValue_dis text-disable">
                        {data?.accHolderName}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                </Grid>
              </>
            }
          </>
        )}
      </div>
    </>
  );
};

export default DisbursementFormTermDetails;
